import React, { Component }  from 'react'
import { Icon, Modal, Button, Table } from 'semantic-ui-react'

class PaymentsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orNumber: '',
      orDate: undefined,
      amount: '',
      showModal: false,
      studentName: '',
      paymentId: '',
    };
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  componentDidMount() {
    let studentName = '';
    if (this.props.payment.student) {
      studentName = this.props.payment.student.lastName + ', ' + this.props.payment.student.firstName;
    }
    this.setState({
      orNumber: this.props.payment.orNumber,
      orDate: this.props.payment.orDate,
      amount: this.props.payment.amount,
      paymentId: this.props.payment.paymentId,
      studentName
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (JSON.stringify(prevProps.payment) !== JSON.stringify(this.props.payment) ) {
      let studentName = '';
      if (this.props.payment.student) {
        studentName = this.props.payment.student.lastName + ', ' + this.props.payment.student.firstName;
      }
      this.setState({
        orNumber: this.props.payment.orNumber,
        orDate: this.props.payment.orDate,
        amount: this.props.payment.amount,
        paymentId: this.props.payment.paymentId,
        studentName
      })
    }
  }

  render() {

    return (
      <Modal
        trigger={
          <Button icon size='tiny' onClick={this.openModal}>
            <Icon name='eye' />
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>{`Payment for Student: ${this.state.studentName}`}</Modal.Header>
        <Modal.Content>
        <Table basic='very' celled size='small'>
          <Table.Body>
            <Table.Row>
              <Table.Cell collapsing>
                <strong>OR Number</strong>
              </Table.Cell>
              <Table.Cell>{this.state.orNumber}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <strong>OR Date</strong>
              </Table.Cell>
              <Table.Cell>{this.state.orDate}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell collapsing>
                <strong>Amount</strong>
              </Table.Cell>
              <Table.Cell>{this.state.amount}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        </Modal.Content>
        <Modal.Actions>

        </Modal.Actions>
      </Modal>
    )
  }
};

export default PaymentsView;
